import { Scan } from "./Scan";
import { Widget } from "./Widget";

export class PopUpComponent{
    popUpTitle: string = "";
    scans: Scan[] = [];
    widgets: Widget[]  = [];
    // nextPopUpAutoOpen: boolean = false;
    completeStep: boolean = false;
    triggerNextAction: boolean = false;
    plateBatching: boolean = false;
    plateUnbatching: boolean = false;
    widgetCount: number = 0;
    availableRedoList: Array<string> = [];
}